import type { RootState } from '..';
import type { AppState, DrawerComponentType } from './types';

export const getAppState = (state: RootState): AppState => state.app;
export const getHistoryTicketQuantity = (state: RootState): number => getAppState(state).historyTicketQuantity;
export const getIsDrawerOpen = (state: RootState): boolean => getAppState(state).isDrawerOpen;
export const getDrawerComponentType = (state: RootState): DrawerComponentType => getAppState(state).drawerComponent;
export const getisInfoOpen = (state: RootState): boolean => getAppState(state).isInfoOpen;
export const getConnectionErrorCount = (state: RootState): number => getAppState(state).connectionErrorCount;
